﻿import * as Model from './identityclaim.model';

export interface IIdentityPrincipal {
    email: string;
    name: string;
    jwt: string;
    expires: string;
    claims: Array<Model.IIdentityClaim>;
}


export class IdentityPrincipal {
    email: string;
    name: string;
    jwt: string;
    expires: string;
    claims: Array<Model.IdentityClaim>;
}